const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Prefix relative (uploaded) image paths with the backend URL; leave full URLs as-is.
export function resolveImg(url) {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  return `${BACKEND_URL}${url}`;
}

// Fallback content so the UI renders instantly before /api/content resolves.
export const DEFAULT_CONTENT = {
  brand_name_1: "Meals on Wheels",
  brand_name_2: "Tralee",
  logo_image:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_boring-blackburn-8/artifacts/47d5976f38ab9204_IMG_1408.jpeg",
  hero_eyebrow: "Christmas 2026 · Tralee, Co. Kerry",
  hero_line_1: "Give someone",
  hero_line_2: "Christmas",
  hero_line_3: "Volunteer a shift.",
  hero_paragraph:
    "Every Christmas Day and Christmas Eve, Meals on Wheels Tralee cooks, packs and delivers a hot dinner to neighbours who'd otherwise spend the day alone. A few hours of your time changes theirs.",
  hero_cta: "Click here to choose your shift",
  hero_note: "24 & 25 December · Free · All welcome",
  hero_image:
    "https://images.unsplash.com/photo-1710092784814-4a6f158913b8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  ribbon_words: ["Cook", "Pack", "Deliver", "Serve", "Welcome", "Share a cuppa", "Wash up", "Give Christmas"],
  manifesto_eyebrow: "Why it matters",
  manifesto_title: "No one in Tralee should be alone at Christmas.",
  chapters: [
    { title: "A dinner, and a knock at the door", body: "", img: "" },
    { title: "Made in Tralee, by neighbours", body: "", img: "" },
    { title: "Give a few hours, not your whole day", body: "", img: "" },
  ],
  signup_eyebrow: "Choose your shift",
  signup_instruction: "Click any time below that suits you — it only takes a minute to sign up.",
  signup_title: "Pick a day, a role, a time.",
  signup_paragraph:
    "Every slot below is a real job on the day. Choose the time that suits you — we'll confirm by email and follow up with the details.",
  video_eyebrow: "See it in action",
  video_title: "This is Christmas in Tralee.",
  video_paragraph:
    "A glimpse of last year's Christmas with Meals on Wheels Tralee — the cooking, the music, the dinners delivered. This year, it could be you in the Santa hat.",
  video_url: "/api/images/6ad3f9491016d30739dda2ec",
  howto_eyebrow: "How to sign up",
  howto_title: "Three easy steps and you're in.",
  howto_steps: [
    {
      title: "Choose your day & job",
      body: "Below you'll find Christmas Day and Christmas Eve. Pick a job that suits you — cooking, driving, serving, washing up. No experience needed.",
    },
    {
      title: "Pick a time",
      body: "Every time slot shows exactly how many places are left. Choose the one that fits your day — a couple of hours is all it takes.",
    },
    {
      title: "Fill in your details",
      body: "Just your name, phone number and email. Your confirmation lands in your inbox straight away, with a link to change or cancel any time.",
    },
  ],
  howto_note: "Prefer to talk to a person? Ring us and we'll book you in over the phone.",
  onday_title: "On the day: sign in at the office first",
  onday_body:
    "When you arrive for your shift, come to our office before anything else. We'll sign you in there and give you all the guidance you need for the day.",
  footer_eyebrow: "Get in touch",
  footer_prompt: "Questions before you sign up? We'd love to hear from you.",
  contact_phone: "066-7165071",
  contact_email: "mealsonwheelstralee@gmail.com",
  contact_address: "Tralee Community Development Project, Upper Rock Street, Tralee, Co. Kerry, V92 WR9P",
  charity_no: "20158316",
  footer_big_text: "MEALS ON WHEELS",
};
